import { Routes, Route } from 'react-router-dom';
import Landing from './Landing';
import Login from './Login';
import IgCallback from './IgCallback';
import Privacy from './legal/Privacy';
import Terms from './legal/Terms';
import DataDeletion from './legal/DataDeletion';
import MediaKit from './MediaKit';

export default function PublicRoutes() {
  return (
    <Routes>
      <Route index element={<Landing />} />
      <Route path="login" element={<Login />} />
      <Route path="ig-callback" element={<IgCallback />} />
      <Route path="privacy" element={<Privacy />} />
      <Route path="terms" element={<Terms />} />
      <Route path="data-deletion" element={<DataDeletion />} />
      {/* Public creator media kit (shared via "Отправить о себе"). No login. */}
      <Route path="c/:handle" element={<MediaKit />} />
    </Routes>
  );
}
